export default __webpack_public_path__ + "static/media/fit.e309da88.png";